import LoadingDots from "../../UI/LoadingDots";
import Curl from "../../APIPlaygroundComponents/Curl";
import { memo, useMemo, useState } from "react";
import classes from "./ComplexityDescription.module.scss"
import { DDD } from "../../../lib/ddd/ddd";
import {useEffect} from "react"
import fakeDDDIMinimalResponse from "../_fakeDDDIMinimalResponse.json";
import fakeUIMiminalResponse from "../_fakeUIMinimalResponse.json";
import { useQuery } from '@tanstack/react-query'
import Button from "../../UI/Button";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const KeysDescription =({mainData, search}) =>{
    const [tableFieldsArr, setTableFieldArr] = useState([]);
    const [tableDetailsArr, setDetailsArr] = useState([]);
    const [validShows, setValidShows] =  useState({});

    useEffect(() =>{
        if(!mainData) return;
        let [mainTableArr, detailTableArr] = buildTablesArrayFromServerResponse(mainData.DDDI_GetNew, mainData.UI_GetNew);
        setTableFieldArr(mainTableArr);
        setDetailsArr(detailTableArr);

    }, [mainData]);

    /**
     * 
     * @param {*} dddi DDDI_GetNew server response
     * @param {*} ui UI_GetNew response
     * @returns [[a],[b]]
     *  a:array = [{fieldName:string, ui:object},...]
     *  b:array = [{detail:string, fields:array = [{fieldName:string, ui:object},...]},...]
     */
    const buildTablesArrayFromServerResponse = (dddi, ui) =>{
        if(!dddi || !ui || !dddi.Invoice?.Invoice || !ui.Invoice)
            return [[],[]];

        let DDDI_GetNew = dddi.Invoice?.Invoice;
        let UI_GetNew = ui.Invoice;
        let ret = [];
        let {_details, ...main} = DDDI_GetNew;
        for(let fieldName in main){
            let field = {};
            field.fieldName = fieldName;
            field.ui = null;
            if(UI_GetNew.hasOwnProperty(fieldName)){
                field.ui = UI_GetNew[fieldName]
            }
            ret.push(field);
        }
        let dret = [];
        for(let detail  in _details){
            if(!_details[detail] || _details[detail].length === 0)
                continue;
            let tmpd = {};
            tmpd.detail = detail;
            tmpd.fields = [];
            for(let fieldName  in _details[detail][0]){
                let field = {};
                field.fieldName = fieldName;
                if(UI_GetNew["_details"][detail] && UI_GetNew["_details"][detail].length > 0 && UI_GetNew["_details"][detail][0][fieldName])
                    field.ui = UI_GetNew["_details"][detail][0][fieldName];
                tmpd.fields.push(field);
            }
            dret.push(tmpd);
        }
        return [ret, dret];
    }

    const onValidClick = (fieldName) =>  {
        setValidShows({...validShows, [fieldName]:!validShows[fieldName]});
    }

    return(<>
    <table className="table table-sm">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col">Required</th>
                </tr>
            </thead>
            <tbody style={{fontSize:"0.8rem"}}>
                {tableFieldsArr.map(({fieldName, ui}) => {
                    if(search && search.trim().length > 0 && fieldName.toLowerCase().indexOf(search.toLowerCase()) < 0)
                        return;
                    return (<>
                        <tr className={ui?.notInMinimal ? classes["normalRow"] : ""}>
                            <td>{/* {ui.ValidValues ? 
                                <><Button onClick={() =>{setValidShows({...validShows, [fieldName]:!validShows[fieldName]})}}>
                                    {validShows[fieldName] ? <KeyboardArrowDownIcon/> : <KeyboardArrowRightIcon/>}
                                </Button></> : <></>
                            } */}
                            {ui?.ValidValues && <>
                                {validShows[fieldName] ? <KeyboardArrowDownIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/> : <KeyboardArrowRightIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/>}
                            </>}
                            </td>
                            <th scope="row">{fieldName}</th>
                            <td>{ui?.Type}</td>
                            <td>{ui?.Trans?.Tooltip || ui?.Trans?.Title}</td>
                            <td style={{textAlign:"center"}}>{ui?.Mandatory ? 
                                <span><i className="ti-check" /></span>
                                 : 
                                <span><i className="ti-minus" /></span>
                                }</td>
                        </tr>
                        {ui?.ValidValues && validShows[fieldName] && 
                            <tr style={{width:"100%"}}>
                                <td colspan="100%">
                                    <div>Value set:</div>
                                    
                                    <div className={`d-flex p-2 w-100 ${classes["valid-values"]}`} >
                                    <ul>
                                        {ui?.ValidValues.map((val, i) =>{
                                            return(<><li><span style={{fontWeight:"700"}}>{val.Code}</span> ({val.UI})</li></>)
                                        })}
                                    </ul>
                                    </div>
                                </td>
                            </tr>}
                    </>)
                })}
            </tbody>
        </table>
        <p>Details:</p>
        {tableDetailsArr.map(({detail, fields, notInMinimal}) => {
            return (
            <>
            <p className={classes["detailTableTitle"]}>{detail}</p>
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">Name</th>
                        <th scope="col">Type</th>
                        <th scope="col">Description</th>
                        <th scope="col">Required</th>
                    </tr>
                </thead>
                <tbody className={notInMinimal ? classes["normalRow"] : ""} style={{fontSize:"0.8rem"}}>
                    {fields.map(({fieldName, ui}) => {
                        if(search && search.trim().length > 0 && fieldName.toLowerCase().indexOf(search.toLowerCase()) < 0)
                            return;
                        return (<>
                            <tr className={ui?.notInMinimal ? classes["normalRow"] : ""}>
                                <td>
                                    {ui?.ValidValues && <>
                                        {validShows[fieldName] ? <KeyboardArrowDownIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/> : <KeyboardArrowRightIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/>}
                                    </>}
                                </td>
                                <th scope="row">{fieldName}</th>
                                <td>{ui?.Type}</td>
                                <td>{ui?.Trans?.Tooltip || ui?.Trans?.Title}</td>
                                <td style={{textAlign:"center"}}>{ui?.Mandatory ? 
                                    <span><i className="ti-check" /></span>
                                    : 
                                    <span><i className="ti-minus" /></span>
                                    }</td>
                            </tr>
                            {ui?.ValidValues && validShows[fieldName] && 
                            <tr style={{width:"100%"}}>
                                <td colspan="100%">
                                    <div>Value set:</div>
                                    
                                    <div className={`d-flex p-2 w-100 ${classes["valid-values"]}`} >
                                    <ul>
                                        {ui?.ValidValues.map((val, i) =>{
                                            return(<><li><span style={{fontWeight:"700"}}>{val.Code}</span> ({val.UI})</li></>)
                                        })}
                                    </ul>
                                    </div>
                                </td>
                            </tr>}
                        </>)
                    })}
                </tbody>
            </table>
            </>)
        })}
    </>)
}
export default KeysDescription;
